module.exports = __webpack_public_path__ + "static/media/file.f58ae165.svg";